import React, { useEffect } from 'react';
import { useState } from 'react';

const ShuffleMessage = (props) => {

    const {
        data,
        interval
    } = props

    const [state, setState] = useState({
        messageIndex: 0
    })

    useEffect(() => {
        const messageChangeTimeout = setTimeout(() => {
            let currentIdx = state.messageIndex;
            setState(prevState => ({ ...prevState, messageIndex: currentIdx + 1 }))
        }, interval);
        
        return () => clearTimeout(messageChangeTimeout);
    }, [state.messageIndex]);

    return (
        <div className="mt-4">
            <h3>
                {data[state.messageIndex % data.length]}
            </h3>
        </div>
    )
}

export default ShuffleMessage